import React from 'react';
import OnboardedSolutionDetailsTab from './OnboardedSolutionDetails';
import CertifiedSolutionDetailsTab from './CertifiedSolutionDetails';
import DeliveryReadySolutionDetailsTab from './DeliveryReadySolutionDetails';
import LicenseDetailsTab from './LicenseDetails';
import DeltaMBNDetailsTab from './MbnDetails';


function Repository ({ tab }) {

    switch (tab) {
        case "Created Solution":
            return <OnboardedSolutionDetailsTab />;
        case "Certified Solution":
            return <CertifiedSolutionDetailsTab />;
        case "Delivery Ready Solution":
            return <DeliveryReadySolutionDetailsTab />
        case "License":
            return <LicenseDetailsTab />
        case "Delta MBN":
            return<DeltaMBNDetailsTab />
        default:
            return <div className='tab-content'>Content for {tab}</div>;
    }
}

export default Repository;